export default {

  //заполнить данные по бонусам
  loadBonuses(state, data){
    state.bonuses=data;
  },

  //заполнить список типов партнеров
  loadPartnerTypes(state, data){
    state.partnerTypes=data;
  },

    //заполнить список типов партнеров
    loadBonusPackages(state, data){
        state.bonusPackages=data;
    },

  //обновить бонус
  editBonus(state, editdata){
    var ind= state.bonuses.findIndex(x=>x.id==editdata.id)
    if(ind!=-1&&ind!=undefined){
      state.bonuses.splice(ind,1,editdata);
    }
  },

  //добавить бонус
  addBonus(state, newdata){
    state.bonuses.push(newdata)
  },

  //удалить бонус
  deleteBonus(state, BonusId){
    var ind= state.bonuses.findIndex(x=>x.id==BonusId)
    if(ind!=-1&&ind!=undefined){
      state.bonuses.splice(ind,1);
    }
  },

}
